<template>
  <el-select :value="valueTitle" :clearable="clearable" @clear="clearHandle" v-bind="$attrs" v-on="$listeners">
    <el-option :value="valueTitle" :label="valueTitle">
      <el-tree id="tree-option"
        ref="selectTree"
        :accordion="accordion"
        :data="options"
        :props="props"
        :node-key="props.value"
        :default-expanded-keys="defaultExpandedKey"
        @node-click="handleNodeClick">
        <p slot-scope="{node,data}" class="treeLabel" :class="{disabled:areaTree&&data.isView===1}">
            {{node.label}}
        </p>
      </el-tree>
    </el-option>
  </el-select>
</template>

<script>
const valueEquals = (a, b) => {
    // see: https://stackoverflow.com/questions/3115982/how-to-check-if-two-arrays-are-equal-with-javascript
    if (a === b) return true
    if (!(a instanceof Array)) return false
    if (!(b instanceof Array)) return false
    if (a.length !== b.length) return false
    for (let i = 0; i !== a.length; ++i) {
        if (a[i] !== b[i]) return false
    }
    return true
}

export default {
    name: 'select-tree',
    inheritAttrs: false,
    props: {
        /* 配置项 */
        props: {
            type: Object,
            default: () => {
                return {
                    value: 'id', // ID字段名
                    label: 'name', // 显示名称
                    children: 'children' // 子级字段名
                }
            }
        },
        // 是否为辖区树，辖区树要根据isView字段判断显示
        areaTree: {
            type: Boolean,
            default: false
        },
        /* 选项列表数据(树形结构的对象数组) */
        options: {
            type: Array,
            default: () => { return [] }
        },
        /* 初始值 */
        value: {
            type: [String, Number],
            default: () => { return null }
        },
        /* 可清空选项 */
        clearable: {
            type: Boolean,
            default: () => { return true }
        },
        /* 自动收起 */
        accordion: {
            type: Boolean,
            default: () => { return false }
        }
    },
    data() {
        return {
            valueId: this.value, // 初始值
            valueTitle: '',
            defaultExpandedKey: []
        }
    },
    watch: {
        value() {
            this.valueId = this.value
            this.initHandle()
        },
        valueId(newVal, oldVal) {
            this.$emit('input', newVal)
        }
    },
    mounted() {
        this.initHandle()
    },
    methods: {
        emitChange(val) {
            if (!valueEquals(this.valueId, val)) {
                this.$emit('change', val)
            }
        },
        // 初始化值
        initHandle() {
            if (this.valueId) {
                this.valueTitle = this.$refs.selectTree.getNode(this.valueId).data[this.props.label] // 初始化显示
                this.$refs.selectTree.setCurrentKey(this.valueId) // 设置默认选中
                this.defaultExpandedKey = [this.valueId] // 设置默认展开
            } else {
                this.valueTitle = ''
                this.defaultExpandedKey = []
            }
            this.$nextTick(() => {
                let scrollWrap = document.querySelectorAll('.el-scrollbar .el-select-dropdown__wrap')[0]
                let scrollBar = document.querySelectorAll('.el-scrollbar .el-scrollbar__bar')
                scrollWrap.style.cssText = 'margin: 0px; max-height: none; overflow: hidden;'
                scrollBar.forEach(ele => {
                    ele.style.width = 0
                })
            })
        },
        // 切换选项
        handleNodeClick(node, a, c) {
            if (this.areaTree && node.isView === 1) {
                return false
            } else {
                this.valueTitle = node[this.props.label]
                const newVal = node[this.props.value]
                if (!valueEquals(this.valueId, newVal)) {
                    this.emitChange(newVal)
                }
                this.valueId = newVal
                this.$emit('getValue', this.valueId)
                this.defaultExpandedKey = []
            }
        },
        // 清除选中
        clearHandle() {
            this.valueTitle = ''
            this.valueId = null
            this.defaultExpandedKey = []
            this.clearSelected()
            this.$emit('getValue', null)
        },
        /* 清空选中样式 */
        clearSelected() {
            let allNode = document.querySelectorAll('#tree-option .el-tree-node')
            allNode.forEach((element) => element.classList.remove('is-current'))
        }
    }
}
</script>

<style scoped lang="scss">
  .el-scrollbar .el-scrollbar__view .el-select-dropdown__item{
    height: auto;
    max-height: 274px;
    padding: 0;
    overflow: hidden;
    overflow-y: auto;
  }
  .el-select-dropdown__item.selected{
    font-weight: normal;
  }
  ul li >>>.el-tree .el-tree-node__content{
    height:auto;
    padding: 0 20px;
  }
  .el-tree-node__label{
    font-weight: normal;
  }
  .el-tree >>>.is-current .el-tree-node__label{
    color: #409EFF;
    font-weight: 700;
  }
  .el-tree >>>.is-current .el-tree-node__children .el-tree-node__label{
    color:#606266;
    font-weight: normal;
  }
  p.treeLabel {
      width: 100%;
      margin: 0;
      &.disabled {
        color: #ccc;
        cursor: not-allowed;
      }
  }
</style>



// WEBPACK FOOTER //
// src/components/global/SelectTree.vue